export default "__VITE_ASSET__CeOpg7lB__"